import { useLocation } from "react-router-dom";

export default function currentPortal() {
    const location = useLocation();
    return location.pathname.split("/").filter(s => s !== "")[0];
}